import { Component, h } from 'preact'
import Card from '../cards/index'
import Phrase from '../../libs/translationsUtils/phrase'

export interface Category {
  id: number,
  title: string,
  url: string,
  description: string,
  thumbnailUrl: string,
  heroImageUrl: string,
  showDescriptionOnHomepage: boolean,
  topicCount: number,
  replyCount: number
}

export interface ParentCategory extends Category {
  subforums: Array<Category>
}

interface Props {
  title: string,
  selectedTemplate: number,
  parentCategories: Array<ParentCategory>
}

class CommunityCategoryWrapper extends Component<Props> {
  constructor (props: Props) {
    super(props)
    this.getMetadata = this.getMetadata.bind(this)
  }

  templates = ['big-card', 'small-card']

  getMetadata (categories: Array<Category>) {
    let totalTopicCount = 0
    let totalReplyCount = 0

    categories.forEach(category => {
      totalTopicCount += category.topicCount
      totalReplyCount += category.replyCount
    })

    return (
      <ul class='list--dot-seperated community-category__card-metadata'>
        <li class='qa-forum-overview-topic-counter'>
          <Phrase m='Forum' p='forumList.meta.counter.topic' count={{ n: totalTopicCount.toString() }} />
        </li>
        <li class='qa-forum-overview-post-counter'>
          <Phrase m='Forum' p='forumList.meta.counter.post' count={{ n: totalReplyCount.toString() }} />
        </li>
      </ul>
    )
  }

  render ({ title, parentCategories, selectedTemplate }: Props) {
    return (
      <section className='full-width Template-brand-featured qa-community-category-container community-category-container homepage-widget-wrapper'>
        <div class='sitewidth'>
          <div class='col'>
            {
              title ? <h3 className='widget__heading'>{title}</h3> : null
            }

            <ul className='community-category-list'>
              { parentCategories.map((item: ParentCategory, idx) => {
                const metadata = this.getMetadata(item.subforums)
                return (
                  <Card
                    customClass={`community-category__card community-category__card-${this.templates[selectedTemplate]}`}
                    idx={idx}
                    title={item.title}
                    metadata={metadata}
                    imageSrc={item.thumbnailUrl}
                    navigation={{
                      url: item.url
                    }}
                  />
                )
              }) }
            </ul>
          </div>
        </div>
      </section>
    )
  }
}

export default CommunityCategoryWrapper
